import { memo, ReactNode, useReducer } from "react";

import styles from "./style.module.scss";

export const floatingUIPortalId = "mimic2PopperPortal";

export const FloatingUIPortal = memo<{ children: ReactNode | ReactNode[] }>(({ children }) => {
  return (
    <>
      {children}
      <div id={floatingUIPortalId} className={styles.root} />
    </>
  );
});


export function useGetFloatingUIPortalElement(recheckTimout = 16) {
  const [ , forceUpdate ] = useReducer((x) => x + 1, 0);

  const portalElement = document.querySelector(`#${floatingUIPortalId}`);

  if (!portalElement) {
    setTimeout(forceUpdate, recheckTimout);
  }

  return portalElement;
}